// extracted by mini-css-extract-plugin
export default {"box":"VerticalLinearStep_box__TQuCx","stepActive":"VerticalLinearStep_stepActive__D49ZG","step":"VerticalLinearStep_step__5iHwx","breakline":"VerticalLinearStep_breakline__nav60"};